import { useTranslations } from '@vocab/react';
import { Card, Divider, Rating, Stack, Text } from 'braid-design-system';
import { SkeletonLoader } from '../../../shared/components/SkeletonLoader';
import type { MonthPickerValue } from '../../type';
import translations from './.vocab';
import { WorkHistoryDetails } from './WorkHistoryDetails';

interface ReviewPreviewProps {
  rating: number;
  genericTitle?: string;
  isJobTitleUpdating?: boolean;
  isLocationUpdating?: boolean;
  isStillWorkHere?: boolean;
  jobTitle?: string;
  location?: string;
  workHistoryFrom?: MonthPickerValue;
  workHistoryTo?: MonthPickerValue;
}

export const ReviewPreview = ({
  rating,
  jobTitle,
  isJobTitleUpdating,
  location,
  isLocationUpdating,
  workHistoryFrom,
  workHistoryTo,
  isStillWorkHere,
  genericTitle,
}: ReviewPreviewProps) => {
  const { t } = useTranslations(translations);

  const formattedGenericTitle = genericTitle
    ?.trim()
    .replace(/^./, (c) => c.toUpperCase());
  const displayJobTitle = genericTitle ? formattedGenericTitle : jobTitle;

  return (
    <Card>
      <Stack space="large">
        <Text weight="strong">{t('How your information will appear')}</Text>
        <Divider />
        <Stack space="medium">
          <Rating rating={rating}></Rating>

          {isJobTitleUpdating ? (
            <SkeletonLoader />
          ) : (
            <>
              {displayJobTitle ? (
                <Text weight="strong">{displayJobTitle}</Text>
              ) : (
                <Text weight="strong" tone="secondary">
                  <i>{t('Job title')}</i>
                </Text>
              )}
            </>
          )}

          {isLocationUpdating ? (
            <SkeletonLoader />
          ) : (
            <>
              {location && <Text>{location}</Text>}
              {!location && (
                <Text tone="secondary">
                  <i>{t('Location')}</i>
                </Text>
              )}
            </>
          )}

          <WorkHistoryDetails
            workHistoryFrom={workHistoryFrom}
            workHistoryTo={workHistoryTo}
            isStillWorkHere={isStillWorkHere}
          />
        </Stack>
      </Stack>
    </Card>
  );
};
